// src/routes/MainRoutes.jsx
import React from "react";
import { Route } from "react-router-dom";
import MainLayout from "../components/MainLayout";
import Home from "../pages/Home/Home";
import Insurance from "../pages/Insurance/Insurance";
import RechargeAndBillPayment from "../pages/Recharge/RechargeAndBillPayment";
import AboutUs from "../pages/AboutUs/AboutUs";
import ContactUs from "../pages/ContactUs/ContactUs";
import RefundPolicy from "../pages/Policies/RefundPolicy";
import GrievancePolicy from "../pages/Policies/GrievancePolicy";
import PrivacyPolicy from "../pages/Policies/PrivacyPolicy";
import TermsAndConditions from "../pages/Policies/TermsAndConditions";
import FAQ from "../pages/FAQ/FAQ";

// RECHARGE ROUTES
import MobileRecharge from "../pages/Recharge/MobileRecharge";
import DthRecharge from "../pages/Recharge/DthRecharge";
import GooglePlayRedeemCode from "../pages/Recharge/GooglePlayRedeemCode";
import RechargeOrderConfirmation from "../pages/Recharge/OrderConfirmation";
import RechargeOrderSummary from "../pages/Recharge/OrderSummary";

// BILL PAYMENT ROUTES
import BillPayment from "../pages/BillPayment/BillPayment";
import BillPaymentOrderSummary from "../pages/BillPayment/OrderSummary";
import BillPaymentOrderConfirmation from "../pages/BillPayment/OrderConfirmation";

import Profile from "../pages/Profile/Profile";
import Transactions from "../pages/Wallet/Transactions";
import Wallet from "../pages/Wallet/Wallet";
import CreditCardToBankTransfer from "../pages/CreditCardTransfer/CreditCardToBankTransfer";
import PaymentStatus from "../pages/Wallet/PaymentStatus";

// import Recharge from '../pages/Recharge';

const MainRoutes = (
  <Route element={<MainLayout />}>
    <Route path="/" element={<Home />} />

    <Route
      path="/recharge-and-bill-payment"
      element={<RechargeAndBillPayment />}
    />
    <Route path="/mobile-recharge" element={<MobileRecharge />} />
    <Route path="/dth-recharge" element={<DthRecharge />} />
    <Route path="/google-play-redeem-code" element={<GooglePlayRedeemCode />} />
    <Route path="/recharge-order-summary" element={<RechargeOrderSummary />} />
    <Route
      path="/recharge-order-confirmation"
      element={<RechargeOrderConfirmation />}
    />

    <Route path="/bill-payment/:category" element={<BillPayment />} />
    <Route
      path="/bill-payment/order-summary"
      element={<BillPaymentOrderSummary />}
    />
    <Route
      path="/bill-payment/order-confirmation"
      element={<BillPaymentOrderConfirmation />}
    />

    <Route path="/insurance" element={<Insurance />} />

    <Route
      path="/credit-card-to-bank-transfer"
      element={<CreditCardToBankTransfer />}
    />

    <Route path="/profile" element={<Profile />} />
    <Route path="/transactions" element={<Transactions />} />

    <Route path="/wallet" element={<Wallet />} />

    <Route path="/about-us" element={<AboutUs />} />
    <Route path="/contact-us" element={<ContactUs />} />
    <Route path="/privacy-policy" element={<PrivacyPolicy />} />
    <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
    <Route path="/refund-policy" element={<RefundPolicy />} />
    <Route path="/grievance-policy" element={<GrievancePolicy />} />
    <Route path="/faq" element={<FAQ />} />
    <Route path="/support" element={<ContactUs />} />

    <Route path="/payment-status" element={<PaymentStatus />} />

    {/* Add more main routes here */}
  </Route>
);

export default MainRoutes;
